import React, { useState ,useEffect} from 'react';
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Select
} from '@chakra-ui/react'
import { VscAdd } from 'react-icons/vsc';
import { useDispatch,useSelector } from 'react-redux';
import { createCiudad, getCiudades } from '../../features/ciudadSlice';
import { getListSelectPais } from '../../features/paisSlice';
export const ModalAgregarCiudad = ({ page, perPage }) => {
    const dispatch = useDispatch();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const initialValues = { descripcion: '', paisId: '' };
    const [indice, setIndice] = useState(initialValues);

    const { paises } = useSelector((state) => state.paises);

    useEffect(() => {
        if (isModalOpen) {
            dispatch(getListSelectPais());
        }
    }, [isModalOpen, dispatch]);


    const handleModalOpen = () => setIsModalOpen(true);
    const handleModalClose = () => {
        setIsModalOpen(false);
        setIndice(initialValues);
    };

    const handleSave = () => {
        dispatch(createCiudad(indice)).then(() =>{
            dispatch(getCiudades({ page, perPage })); // Usa los valores pasados como props y Actualiza 
            setIsModalOpen(false)
            setIndice(initialValues)
        });
       
    }


    return (
        <>
            <Button
                colorScheme="blue"
                _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" }}}
                aria-label="Agregar"
                leftIcon={<Icon as={VscAdd} fontSize="lg" />}
                variant="solid"
                rounded={'xl'}
                onClick={handleModalOpen}
            >
                Nuevo Registro
            </Button>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay 
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">AGREGAR NUEVA CIUDAD</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight="semibold">CIUDAD</FormLabel>
                                <Input
                                    placeholder="Ingrese el nombre de la ciudad"
                                    type="text"
                                    onChange={(e) => setIndice({ ...indice, descripcion: e.target.value })}
                                />
                            </FormControl>
                            
                            <FormControl isRequired>
                                <FormLabel fontWeight={'semibold'}>PAIS</FormLabel>
                                <Select
                                    placeholder="Selecciona un país"
                                    onChange={(e) => setIndice({ ...indice, paisId: e.target.value })}
                                    value={indice.pais}
                                >
                                    {paises.map((pais) => (
                                        <option key={pais.id} value={pais.id}>
                                            {pais.descripcion}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>

                        </Stack>
                    
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="red" _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }} size="lg" mr={3} onClick={handleModalClose} borderRadius="xl">
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="blue"
                            _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleSave}
                            borderRadius="xl"
                            disabled={!indice.descripcion.trim() || !indice.paisId}
                        >
                            GUARDAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
